import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  'photosGalleryLoaded': false,
  'photoGalleryById': {},
  'currentPage': 1, // ADDED: Persists the current page across the app
}

const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    loadPhotosGallery: (state, action) => {
      state.photosGalleryLoaded = true;
      state.photos = action.payload.photos;
      const photoGalleryById = {}
      action.payload.photos.map(photo => {
        photoGalleryById[photo["photo_id"]] = photo
        return null
      });
  
      state.photoGalleryById = photoGalleryById;
    },
    photoHidden: (state, action) => {
      const photo = action.payload.photo;
      delete state.photoGalleryById[photo["photo_id"]];
    },
    // ADDED: Reducer to save the current page number to Redux
    setGalleryPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetPhotosGallery: (state) => {
      state.photoGalleryById = {}
      state.photosGalleryLoaded = false;
      state.currentPage = 1; // Reset to page 1 on clear
    }
  },
})

// Export the new setGalleryPage action
export const { loadPhotosGallery, photoHidden, setGalleryPage, resetPhotosGallery } = gallerySlice.actions
export default gallerySlice.reducer